<div
  class="acess-trial-component"
  style="width: 100%; height: 100%; background-color: #fffbff; display: flex"
>
  <div
    style="
      flex: 0.5;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    "
  >
    <h1
      style="
        color: var(--material-theme-ref-primary-primary-10, #180064);
        font-family: Roboto;
        font-size: 57px;
        font-style: normal;
        font-weight: 500;
        line-height: 64px;
        max-width: 450px;
        min-width: 450px;
        margin: 0;
      "
    >
      Vem pra NINA!
    </h1>

    <h3
      style="
        margin-top: 20px;
        color: var(--material-theme-black, #000);
        font-family: Roboto;
        font-size: 28px;
        font-style: normal;
        font-weight: 400;
        line-height: 36px;
        max-width: 450px;
      "
    >
      Você ainda não possui acesso completo à dashboard da NINA.
    </h3>

    <div
      class="back"
      style="
        display: flex;
        gap: 30px;
        margin-top: 8vh;
        align-items: center;
        max-width: 450px;
        min-width: 450px;
      "
    >
      <button
        style="
          display: flex;
          width: 258px;
          height: 61px;
          padding: 8px 24px;
          justify-content: center;
          align-items: center;
          gap: var(--corner-16, 16px);
          flex-shrink: 0;
          color: var(--material-theme-sys-light-on-tertiary, #fff);
          text-align: center;
          font-family: Roboto;
          font-size: 22px;
          font-style: normal;
          font-weight: 500;
          line-height: 28px;
          border: none;
          border-radius: 40px;
          background: var(--material-theme-ref-tertiary-tertiary-60, #00a388);
        "
      >
        Obter acesso
      </button>
      <a
        style="
          color: var(--material-theme-sys-light-primary, #5b43d9);
          font-family: Roboto;
          font-size: 22px;
          font-style: normal;
          font-weight: 500;
          line-height: 28px;
          height: 30px;
          text-decoration: none;
          border-bottom: 1px solid #5b43d9;
        "
        >Voltar</a
      >
    </div>
  </div>
  <div
    style="
      flex: 0.5;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    <img src="assets/icons/ninaWaving.svg" alt="" />
  </div>
</div>
